var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImageCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165,
    height: 77,
    viewBox: "0 0 165 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.943,
    height: 35.736,
    fill: "#a5a5a5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-452 -733)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 77,
    rx: 6,
    transform: "translate(452 733)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(477.372 753.739)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.18,247.1a8.416,8.416,0,1,1-8.416,8.416,8.416,8.416,0,0,1,8.416-8.416m0,14.536a6.12,6.12,0,1,0-6.12-6.12,6.12,6.12,0,0,0,6.12,6.12",
    transform: "translate(-82.487 -228.198)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.1,240.437a8.671,8.671,0,1,1-8.67,8.671,8.671,8.671,0,0,1,8.67-8.671m0,14.995a6.324,6.324,0,1,0-6.324-6.324,6.325,6.325,0,0,0,6.324,6.324",
    transform: "translate(-1052.569 -222.042)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.389,17.877l1.294-1.726V12.54a2.209,2.209,0,0,1,.307-1.15,4.5,4.5,0,0,0,.356-2.533c-.561-.612-.306-.765-.306-.765,3.519.408,10.252-.714,10.252-.714,2.091-1.122,12.241-4.641,12.241-4.641C31.112.646,39.783.34,39.783.34,55.492-.834,63.958,1.411,63.958,1.411,72.578,3.859,83.034,10.9,83.034,10.9c23.411.1,29.735,6.426,29.735,6.426l-.612.306s1.173.867,1.326.969a6.661,6.661,0,0,1-.153,1.785l.74.548a1.488,1.488,0,0,1,.6,1.264l-.27,5.941.355.375a.687.687,0,0,1-.154,1.065c-4.352,2.547-11.065,1.314-11.065,1.314h-.46a9.78,9.78,0,1,0-18.487,0h-.638l-49.677-.816-.285-.014a9.895,9.895,0,1,0-19.155-.95l-.094,0L3.288,27.52A3.81,3.81,0,0,1,0,23.746v-4.7a1.943,1.943,0,0,1,.389-1.166m54.9-6.979c17.749,2.244,25.145.51,25.145.51C63.752.571,52.84,1.819,52.84,1.819ZM29.276,8.4a18.918,18.918,0,0,0,5.166,1.227,6.729,6.729,0,0,1,1.042.2l.014,0c1.632.459,14.74.816,14.74.816l-.459-8.867c-9.527-.557-14.536,1.166-14.536,1.166L34.58,3.2c-6.98,2.977-5.3,5.2-5.3,5.2",
    transform: "translate(0 0)",
    fill: "#a5a5a5"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageCar);
export default __webpack_public_path__ + "static/media/no_image_car.ddf42ca93671b8d415a1ec63a581e8bf.svg";
export { ForwardRef as ReactComponent };